import React, { useEffect, useState } from "react";
import BestTour from "../assets/imgs/partners/besttour.png";
import ModernSkyTour from "../assets/imgs/partners/modernskytour.png";
import UHX from "../assets/imgs/partners/uhx.png";
import ABOEX from "../assets/imgs/partners/aboex.png";
import C8 from "../assets/imgs/partners/c_8.png";
import C9 from "../assets/imgs/partners/c_9.png";
import Manejkom from "../assets/imgs/partners/manejkom.png";
import Cicerone from "../assets/imgs/partners/cicerone.png";
import JM from "../assets/imgs/partners/jm.png";
import RedPine from "../assets/imgs/partners/redpine.png";
import A1 from "../assets/imgs/partners/a_1.webp";
import A2 from "../assets/imgs/partners/a_2.jpg";
import A3 from "../assets/imgs/partners/a_3.png";
import A4 from "../assets/imgs/partners/a_4.png";
import C12 from "../assets/imgs/partners/c_12.png";
import B2 from "../assets/imgs/partners/b_2.png";
import H1 from "../assets/imgs/partners/h_1.png";
import H2 from "../assets/imgs/partners/h_2.jpg";
import H3 from "../assets/imgs/partners/h_3.jpg";
import H4 from "../assets/imgs/partners/h_4.png";
import Shilla from "../assets/imgs/partners/shilla.png";
import Shinsegae from "../assets/imgs/partners/shinsegae.png";
import "../components/TextContents.css"

const partnersObj = [
  { title: C8, name: "여행사_Indotravelstore", category: "agency", url: "https://www.indotravelstore.com/" },
  { title: C9, name: "여행사_sulitDreamDestinations", category: "agency", url: "https://sulitdreamdestinations.com.ph/" },
  { title: Manejkom, name: "여행사_manejkom", category: "agency", url: "https://manejkomtravel.com/" },
  { title: Cicerone, name: "여행사_ciceroneTravel", category: "agency", url: "https://www.cicerone-travel.net/" },
  { title: JM, name: "여행사_JMAccess", category: "agency", url: "https://jmtravelph.com/" },
  { title: RedPine, name: "여행사_RedPines", category: "agency", url: "http://www.redpinestravel.com/" },
  { title: UHX, name: "여행사_UHX", category: "agency", url: "https://www.uhxtravelcentral.com/" },
  { title: ABOEX, name: "여행사_UHX", category: "agency", url: "https://www.uhxtravelcentral.com/" },
  { title: A1, name: "항공_cathayPacific" },
  { title: A2, name: "항공_philippineAirlines" },
  { title: A3, name: "항공_cebuPacific" },
  { title: A4, name: "항공_가루다인도네시아" },
  { title: C12, name: "은행_BDO" },
  { title: B2, name: "은행_Maybank" },
  { title: H1, name: "호텔_뉴서울" },
  { title: H2, name: "호텔_스카이파크" },
  { title: H3, name: "호텔_스탠포드" },
  { title: H4, name: "호텔_프린스서울" },
  { title: Shilla, name: "면세점_신라", category: "dutyfree", url: "https://www.shilladfs.com/" },
  { title: Shinsegae, name: "면세점_신세계", category: "dutyfree", url: "https://www.shinsegaedf.com/" },
  { title: BestTour, name: "베스트투어", category: "bus", url: "" },
  { title: ModernSkyTour, name: "모던스카이", category: "bus", url: "" },
];

const Partners = () => {
  const [position, setPosition] = useState(0);
  const [translateY, setTranslateY] = useState(300);

  function onScroll() {
    setPosition(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      if (position >= 900 && translateY >= 0) {
        setTranslateY(moveY => moveY - 1.0);
      }
    }, 0.2);
    return () => clearInterval(id);
  }, [position, translateY]);

  function getUrl(data) {
    return data.title;
  }

  function getSize(type) {
    switch (type) {
      case "agency":
        return "h-[100px] w-[100px]";
      case "bus":
        return "h-[32px]";
      case "dutyfree":
        return "h-[50px]";
      default:
        break;
    }

    return "";
  }

  return (
    <div className="relative flex flex-col gap-5" >
      <div className="flex md:flex-row md:gap-5 h-[180px] rounded-[24px] px-[80px] md:p-[20px] text-[#000] items-center justify-between">
        <div className="w-full relative overflow-hidden">
          <div className="absolute left-0 w-52 md:w-20 bg-gradient-to-r from-white to-white/0 h-full z-10"></div>
          <div className="absolute right-0 w-52 md:w-20 bg-gradient-to-l from-white to-white/0 h-full z-10"></div>
          <div className="w-full h-fit">
            <div className="kts-marquee-container h-fit flex flex-row gap-10" >
              <div className="kts-marquee">
                <div className="kts-initial-child-container">
                  <div className="kts-child">
                    <div className="flex flex-row gap-10 items-center">
                      {
                        partnersObj.filter(item => item.category === "agency" || item.category === "bus" || item.category === "dutyfree").map((item, index) => {
                          return (
                            <div key={index} className="flex-none">
                              <a target="_blank" rel="noreferrer" href={`${item.url}`} >
                                <img
                                  className={getSize(item.category)}
                                  src={getUrl(item)}
                                  alt={item.title}
                                  loading="lazy"
                                /></a>
                            </div>
                          );
                        })
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="kts-marquee">
                <div className="kts-child">
                  <div className="flex flex-row gap-10 items-center">
                    {
                      partnersObj.filter(item => item.category === "agency" || item.category === "bus" || item.category === "dutyfree").map((item, index) => {
                        return (
                          <div key={index} className="flex-none">
                            <a target="_blank" rel="noreferrer" href={`${item.url}`} >
                              <img
                                className={getSize(item.category)}
                                src={getUrl(item)}
                                alt={item.title}
                                loading="lazy"
                              /></a>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Partners;
